export default __webpack_public_path__ + "static/media/fasad3.17c057da.jpeg";